import template from './arrow-box.html';
import './arrow-box.global.css';

export const ArrowBoxComponent = {
  transclude: true,
  template,
};
